var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.notes.length == 0)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"h2 mt-3"},[_vm._v("No notes found")])]):_c('div',_vm._l((_vm.notes),function(note){return _c('TaskNoteCard',{key:note.id,attrs:{"note":note}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }